import { render, staticRenderFns } from "./DraftsListItem.vue?vue&type=template&id=59f48f4b&"
import script from "./DraftsListItem.vue?vue&type=script&lang=js&"
export * from "./DraftsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports